module.exports = __webpack_public_path__ + "static/media/hiring.31eb46a8.svg";